var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.399,
    height: 36,
    viewBox: "0 0 32.399 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-3 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M30,2H8.4A5.4,5.4,0,0,0,3,7.4V34.039A3.6,3.6,0,0,0,8.148,37.3c.432-.216.81-.45,1.206-.684A4.23,4.23,0,0,1,12,35.767a4.284,4.284,0,0,1,2.664.846A7.722,7.722,0,0,0,19.2,38a7.7,7.7,0,0,0,4.536-1.386,4.266,4.266,0,0,1,2.664-.846,4.194,4.194,0,0,1,2.646.846,12.941,12.941,0,0,0,1.206.666,3.6,3.6,0,0,0,5.148-3.24V7.4A5.4,5.4,0,0,0,30,2ZM19.2,27.2H12a1.8,1.8,0,1,1,0-3.6h7.2a1.8,1.8,0,1,1,0,3.6ZM26.4,20H12a1.8,1.8,0,1,1,0-3.6H26.4a1.8,1.8,0,1,1,0,3.6Zm0-7.2H12a1.8,1.8,0,1,1,0-3.6H26.4a1.8,1.8,0,1,1,0,3.6Z",
    fill: "#05b4ef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingIco);
export default __webpack_public_path__ + "static/media/billingIco.af7ddbc1f74a0b1e5a694fbbea1cd5fc.svg";
export { ForwardRef as ReactComponent };